export const isRtl = (language = 'en'):boolean => ['he', 'ar'].includes(language);
